<template>
  <nx-file-uploader
    ref="upload"
    :label="$t('message.wizard.image')"
    name="file"
    :data-vv-name="name"
    :data-vv-scope="scope"
    :data-vv-as="label"
    data-vv-validate-on="input"
    :error-messages="errorMessages"
    :required="required"
    :selected-file-name="selectedFileName"
    :selected-file="selectedFile"
    :show-preview="true"
    @file="onInput"
  ></nx-file-uploader>
</template>
<script>
import FormElement from '@/modules/form/mixins/form-element';
import NxFileUploader from '@/modules/upload/FileUploader';

export default {
  mixins: [FormElement],
  props: {
    value: {
      type: [File],
    },
  },
  data() {
    return {
      selectedFileName: '',
      selectedFile: null,
    };
  },
  methods: {
    onBlur(board) {
      this.flags.focused = false;
      this.$emit('blur', board);
    },
    onInput(file) {
      this.selectedFileName = file.name;
      this.selectedFile = file;
      this.$parentForm.updateField(this.name, file);
      this.$emit('input', file);
    },
  },
  components: {
    NxFileUploader,
  },

};
</script>
